module.exports = __webpack_public_path__ + "static/stm-case-study-two-281e78a2a51744ee7336c6f570218558.webp";